<template>
    <div v-bind:class="readAccessClasses">

        <div class="dx-field">

            <div>
                <DxSelectBox :data-source="platforms"
                             v-model:value="selectedKey"
                             display-expr="text"
                             placeholder="Layout auswählen..." />


            </div>
            <div>
                <DxSelectBox :data-source="skinNames"
                             v-model:value="selectedSet"
                             display-expr="Name"
                             value-expr="Value"
                             placeholder="Set auswählen..." />


            </div>
            <div class="tsBtnDx">
                <DxButton @click="exportLayout()"><i class="fa-thin fa-download"></i></DxButton>
            </div>
        </div>
        <div class="na-list">
            <DxDataGrid v-model:data-source="post.CssProperties"
                        :activeStateEnabled="true"
                        :allowColumnReordering="true"
                        :allowColumnResizing="true"
                        :rowAlternationEnabled="true"
                        @saving="onSaving"
                        @exporting="onExporting"
                        :show-borders="true">
                <DxEditing mode="batch"
                           :allow-updating="true"
                           :allow-adding="true"
                           :allow-deleting="true"
                           startEditAction="click" />
                <DxColumnChooser :enabled="true" />
                <DxColumnFixing :enabled="true" />
                <DxFilterPanel :visible="true" />
                <DxFilterRow :visible="true" />
                <DxHeaderFilter :visible="true" />
                <DxSearchPanel :visible="true" placeholder="Search..." />
                <DxLoadPanel :enabled="true" />
                <DxPaging :page-size="15" />
                <DxPager :visible="true"
                         :allowed-page-sizes="100"
                         :display-mode="full"
                         :show-page-size-selector="true"
                         :show-info="true"
                         :show-navigation-buttons="true" />
                <DxSorting mode="multiple" />
                <DxGroupPanel :visible="true" />
                <DxStateStoring :enabled="false"
                                type="localStorage"
                                storage-key="settingList" />
                <DxExport :enabled="true"
                          :allow-export-selected-data="true" />



                <DxColumn caption='Eigenschaft' name='colName' data-type='string' data-field='Name' :allow-editing="true" />
                <DxColumn caption='Wert' name='colValue' data-type='string' data-field='Value' :allow-editing="true" />


            </DxDataGrid>
        </div>
    </div>
</template>
<script>
    import { DxButton } from 'devextreme-vue/button'
    import {
        DxDataGrid,
        DxColumnChooser,
        DxColumnFixing,
        DxFilterRow,
        DxHeaderFilter,
        DxSearchPanel,
        DxLoadPanel,
        DxSorting,
        DxPaging,
        DxPager,
        DxColumn,
        DxFilterPanel,
        DxStateStoring,
        DxGroupPanel,
        DxExport,
        DxEditing
    } from 'devextreme-vue/data-grid'
    import $ from "jquery"
    import axios from "axios";
    import DxSelectBox from 'devextreme-vue/select-box';

    import { exportDataGrid } from 'devextreme/excel_exporter';
    import { Workbook } from 'exceljs';
    import saveAs from 'file-saver';

    const baseUri = "WebApi.asmx/api/skinService";

    export default {
        name: 'TopicOverview',
        components: {
            DxButton,
            DxDataGrid,
            DxColumnChooser,
            DxColumnFixing,
            DxFilterRow,
            DxHeaderFilter,
            DxSearchPanel,
            DxLoadPanel,
            DxSorting,
            DxPaging,
            DxPager,
            DxFilterPanel,
            DxStateStoring,
            DxColumn,
            DxGroupPanel,
            DxExport,
            DxEditing,
            DxSelectBox
        },

        data() {
            return {
                post: [],
                platforms: [
                    { text: "Esa", key: "~/MasterPages/Esa/Default.master" },
                    { text: "Forsight (BMAS)", key: "~/MasterPages/BMAS/Default.master" },
                    { text: "Forsight (VDMA)", key: "~/MasterPages/VDMA/Default.master" },
                ],
                selectedKey: null,
                selectedSet: null,
                skinNames: [],
            }
        },
        computed: {
            listList() {
                var result = this.$store.state.listStore.listList
                return result
            },
            skinName: {
                get: function () {
                    console.log(this.selectedSet)
                    return this.selectedSet ? this.selectedSet.Name : null;
                },
            },
            masterPageFile: {
                get: function () {
                    // console.log("selectedKey "+this.selectedKey)
                    return this.selectedKey ? this.selectedKey.key : null;
                },
            },

        },
        watch: {
            skinName: function () {
                this.loadSkin();
            },
            masterPageFile: function () {
                this.loadSkin();
            },
            skinNames: function () {
                // console.log("watch " + this.skinNames);

            }
        },

        mounted: function () {

        },
        created: function () {

        },
        methods: {
            onExporting(e) {
                e.component.beginUpdate();
                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet('Data');
                exportDataGrid({
                    component: e.component,
                    worksheet: worksheet
                }).then(function () {
                    workbook.xlsx.writeBuffer().then(function (buffer) {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Data.xlsx');
                    });
                }).then(function () {
                    e.component.endUpdate();
                });
            },
            exportLayout() {

                var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.post));
                // console.log(dataStr)

                var downloadAnchorNode = document.createElement('a');
                downloadAnchorNode.setAttribute("href", dataStr);
                downloadAnchorNode.setAttribute("download", this.selectedKey.text + "Layout.txt");
                document.body.appendChild(downloadAnchorNode);
                downloadAnchorNode.click();
                downloadAnchorNode.remove();
            },

            loadSkin() {
                //console.log(this.skinName);
                return axios
                    .get(baseUri + '/SetAndGetSkinPropertiesVx', { params: { skinNameVx: this.skinName, masterPageFileVx: this.masterPageFile } })
                    .then(res => {
                        this.skinNames = res.data.skinNameListe;
                        console.log(this.skinNames)
                        this.post = res.data.data
                        return res.data.data
                    })
            },

            onSaving(e) {
                var updates = e.changes.filter(m => m.type == "update").map(m => {
                    return $.extend(m.key, m.data)
                })

                var remove = e.changes.filter(m => m.type == "remove").map(m => m.key.SetId)
                var insert = e.changes.filter(m => m.type == "insert").map(m => {
                    m.data.key = m.key
                    return m.data
                })

                var formData = new FormData()
                formData.append("updates", JSON.stringify(updates))
                formData.append("remove", JSON.stringify(remove))
                formData.append("insert", JSON.stringify(insert))
                axios
                    .post(baseUri + '/UpdateSkinPropertyVx', formData)
                    .then(res => {
                        if (res.data.success == true) {
                            //commit('SAVE_LIST_LIST', res.data.data)
                        } else {
                            alert("An error occured while updating: " + res.data.errorMessage)
                        }
                    })


            }
        }
    }



</script>
<style scoped>
    .tsBtnDx {
        width: 30px;
        align-self: center;
        padding-left: 10px;
    }
</style>